import { Box, Grid, Stack, TextField, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { dateformat } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import { FechaField } from '../../../accesos/components/FechaField';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import SelectFieldEquiposComponent from '../../equipos/components/SelectFieldEquipos';
import SelectFieldRondasComponent from '../../rondas/components/SelectFieldRondas';
import { saveJuegosAction } from '../JuegosAction';

const FormJuegos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const equiposStore = Redux.useSelector((state) => state.equipos);
  const juegosStore = Redux.useSelector((state) => state.juegos);

  const activo = juegosStore.activo;

  const initData = {
    lugar: '',
    desc: '',
    grupo: '',
    idRonda: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    lugar: false,
    idRonda: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [equiposSelect, setEquiposSelect] = React.useState([]);

  const [equipoSelect, setEquipoSelect] = React.useState('');
  const [hora, setHora] = React.useState(null);
  const [fecha, setFecha] = React.useState(dateformat(null, {}));

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idRonda: juegosStore.activo.ronda.id,
          idEstatus: activo.estatus.id,
        }),
      300,
    );
    activo.equipos.forEach((value) =>
      setEquiposSelect((old) => [...old, value.equipo]),
    );
    setFecha(dateformat(activo.fechaHora, {}));
    setHora(dateformat(activo.fechaHora, { isHHmm: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!data.idRonda) {
      notify('Falta seleccionar un ronda', { warning: true });
      return;
    }
    if (!fecha) {
      notify('Falta seleccionar la fecha de inicio', { warning: true });
      return;
    }
    if (!hora) {
      notify('Falta seleccionar la hora de inicio', { warning: true });
      return;
    }

    if (equiposSelect.length !== 2) {
      notify('Falta seleccionar 2 equipos', { warning: true });
      return;
    }

    const ids = [];
    equiposSelect.forEach((el) => ids.push(el.id));

    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveJuegosAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          equiposSelect: ids,
          fechaHora: `${fecha} ${hora}`,
        },
        juegosStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={12}>
          <SelectFieldRondasComponent
            value={data.idRonda}
            required
            idTorneo={juegosStore.params.idTorneo}
            onChange={(idRonda) =>
              _handleSetDataField(CONST.ronda.idName, idRonda)
            }
          />
        </Grid>
        <Grid item xs={12} md={12}>
          {equiposSelect.length !== 2 && (
            <SelectFieldEquiposComponent
              value={equipoSelect}
              required
              onChange={(idEquipo) => {
                setEquipoSelect('');
                if (equiposSelect.length < 2) {
                  const item = equiposStore.all.find(
                    (el) => el.id === idEquipo,
                  );
                  setEquiposSelect((old) => [...old, item]);
                }
              }}
            />
          )}
          {equiposSelect.length > 0 && (
            <Box sx={{ mb: equiposSelect.length !== 2 ? 0 : 2 }}>
              {equiposSelect.map((el) => (
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ mt: 1 }}
                >
                  <Typography variant="body1" color="initial">
                    {el.nombre}
                  </Typography>
                  <BotonComponent
                    click={() => {
                      const array = equiposSelect.filter(
                        (tt) => tt.id !== el.id,
                      );
                      setEquiposSelect(array);
                    }}
                    red
                    text="ELIMINAR"
                    deleteIcon
                  />
                </Stack>
              ))}
            </Box>
          )}
        </Grid>

        <Grid item xs={12} md={6}>
          <FechaField
            notDate
            views={['year', 'month', 'day']}
            openTo="month"
            botonCurrentDate={false}
            label={CONST.fecha.tag}
            value={fecha}
            error={!fecha}
            onChange={(e) => setFecha(dateformat(e, {}))}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="time"
            required
            label="Hora de inicio"
            value={hora}
            onChange={(e) => setHora(e.target.value)}
            id={CONST.horaFinal.name}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.grupo.name}
            required
            label={CONST.grupo.label}
            value={data.grupo}
            onChange={(e) =>
              _handleSetDataField(CONST.grupo.name, Number(e.target.value))
            }
            helperText={dataError.grupo ? validMessage.required : null}
            error={dataError.grupo}
            type="number"
            InputProps={{
              inputProps: { min: 1 },
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
            error={dataError.estatus}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.lugar.name}
            label={CONST.lugar.label}
            value={data.lugar}
            multiline
            required
            rows={2}
            onChange={(e) =>
              _handleSetDataField(CONST.lugar.name, e.target.value)
            }
            helperText={dataError.lugar ? validMessage.required : null}
            error={dataError.lugar}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={2}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormJuegos;
